import React, { useState } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { verify } from '../actions/auth';

const Activate = ({ verify }) => {
    const [verified, setVerified] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const { uid, token } = useParams(); // Retrieve uid and token from URL params

    // Login URL - replace with your actual login URL
    const loginUrl = "https://intelirain-app.com/login";

    const verify_account = () => {
        // Keep the original verify functionality
        verify(uid, token);
        // Show modal instead of immediately setting verified to true
        setShowModal(true);
    };

    // Only redirect if modal is closed and user is verified
    if (verified && !showModal) {
        return <Navigate to='/' />;
    }

    // Function to handle proceeding to login
    const handleProceedToLogin = () => {
        // Set verified to true to maintain original flow
        setVerified(true);
        // Hide modal
        setShowModal(false);
        // Redirect to login page
        window.location.href = loginUrl;
    };

    return (
        <div className='container'>
            <div 
                className='d-flex flex-column justify-content-center align-items-center'
                style={{ marginTop: '200px' }}
            >
                <h1>Verify your Account:</h1>
                <button
                    onClick={verify_account}
                    style={{ marginTop: '50px' }}
                    type='button'
                    className='btn btn-primary'
                >
                    Verify
                </button>
            </div>

            {/* Modal */}
            {showModal && (
                <div className="modal show d-block" tabIndex="-1" role="dialog">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Activation Complete</h5>
                                <button 
                                    type="button" 
                                    className="close" 
                                    aria-label="Close"
                                >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <p>Your account has been successfully activated.</p>
                            </div>
                            <div className="modal-footer">
                                <button 
                                    onClick={handleProceedToLogin}
                                    type="button" 
                                    className="btn btn-primary"
                                >
                                    Proceed to Login
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal backdrop */}
            {showModal && (
                <div className="modal-backdrop show"></div>
            )}
        </div>
    );
};

export default connect(null, { verify })(Activate);